module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.695d89a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/title-banner1-type1.png
// module id = GYyT
// module chunks = 1